import React from 'react';
import type { CirculoPresetId } from '@/lib/layouts/types';

const shell = 'h-[52px] w-full rounded overflow-hidden bg-muted/50 mb-1.5 relative';

export const CirculoPickerIcon: React.FC<{ preset: CirculoPresetId }> = ({ preset }) => {
  const arcTop = preset === 'cima';
  return (
    <div className={shell}>
      <span
        data-testid={`post-layout-aspect-circulo-${preset}`}
        className="absolute right-0.5 top-0.5 z-10 rounded bg-black/75 px-1 py-0.5 text-[7px] font-semibold leading-none text-white"
      >
        9:16
      </span>
      <div className="absolute left-1/2 top-[46%] h-[58%] aspect-square -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white/45 bg-white/10" />
      <svg
        aria-hidden
        viewBox="0 0 40 12"
        className={`absolute left-[18%] right-[18%] h-[10px] text-white/70 ${arcTop ? 'top-[8%]' : 'bottom-[8%]'}`}
      >
        <path
          d={arcTop ? 'M 2 10 Q 20 0 38 10' : 'M 2 2 Q 20 12 38 2'}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
